import Cookies from 'js-cookie';
import apiClient from '../_infra/apiClient';
import { loginfo } from '../_infra/util/apiUsageLogger';
import { tryMsAuthSilent } from './ms.service';

export async function Refresh() {
  return await apiClient.get('/fusionRefreshToken_v2');
}

export const loginWithCredentials = async (
  email,
  password,
  gdprConsent,
  gdprTermsVersion,
  gdprPolicyVersion,
) => {
  loginfo();

  try {
    const res = await apiClient.post(
      `/fusionLogin_v2`,
      {
        email: email,
        password: password,
        gdprConsent: gdprConsent,
        gdprTermsVersion: gdprTermsVersion,
        gdprPolicyVersion: gdprPolicyVersion,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    Cookies.set('workplaceId', res.data.workplaceId);
    return res;
  } catch (error) {
    console.error('Login with credentials failed.', error);
  }
};

export const loginWithProvider = async (
  gdprConsent,
  gdprTermsVersion,
  gdprPolicyVersion,
  provider = null,
  instance = null,
) => {
  loginfo();

  try {
    const msRes = await tryMsAuthSilent(instance, ['User.ReadBasic.All']);

    if (msRes) {
      const res = await apiClient.post(
        `/fusionLogin_v2`,
        {
          gdprConsent: gdprConsent,
          gdprTermsVersion: gdprTermsVersion,
          gdprPolicyVersion: gdprPolicyVersion,
          provider: provider,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            MsAuth: `Bearer ${msRes.accessToken}`,
          },
          withCredentials: true,
        },
      );

      Cookies.set('workplaceId', res.data.workplaceId);
      return res;
    } else {
      throw new Error('Failed to authenticate with Microsoft');
    }
  } catch (error) {
    console.error('Login with provider failed.', error);
  }
};

export const createAppSessionFromMsalResult = async (provider) => {
  return await apiClient.post('/fusionLogin_v2', {
    provider,
    gdprConsent: true,
    gdprTermsVersion: 1,
    gdprPolicyVersion: 1,
  });
};

export async function logout() {
  await apiClient.post('/logout');
}
